import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { Legend } from './legend';
import type { RoundProgress as Props } from './round-progress.types';

export const RoundProgress: React.FC<Props> = ({ legend, total, vector }) => (
  <div className="round-progress">
    <div className="round-progress__illustration">
      <svg {...vector.props} aria-labelledby={vector.id}>
        <g {...vector.group}>
          {vector.circles.map(entry => (
            <circle {...entry} key={entry.stroke} />
          ))}
        </g>
      </svg>
      <div className="round-progress__total" id={vector.id}>
        <Text theme={Text.themes.headline}>{total.count}</Text>
        <Text size={Text.sizes.small}>{total.label}</Text>
      </div>
    </div>
    <div>
      <Legend {...legend} />
    </div>
  </div>
);
